module.exports = __webpack_public_path__ + "static/media/CLA_CSV_1.7a466264.svg";